export default function Whitelisting(){
    return (
        // <a className="cr unhideWhitelistFormBTN metaportal_fn_button"><span>Get Yourself Whitelisted</span></a>
        <a className="cr metaportal_fn_button" href="#mintSection"><span>Mint Now</span></a>
    )
}